import { clsx } from 'clsx';
import * as style from './Switcher.css';
import { ArticleHeading1, ArticleHeading4, Responsive, Select, Switch, useDeviceType } from '@cian/ui-kit';
import { TSwitcherProps } from 'shared/types/switcher';
import { WANT_KNOW_TYPE } from 'shared/constants/wantType';
import { EDealType, EOfferType } from 'shared/types/wantType';

export const Switcher: React.FC<TSwitcherProps> = ({ dealType, onActiveDealType, offerType, onActiveOfferType }) => {
  const device = useDeviceType();

  const isPhone = device === 'phone';

  const SwitcherTitle = isPhone ? ArticleHeading4 : ArticleHeading1;

  const textAlign = isPhone ? 'center' : 'left';

  return (
    <div className={clsx(style['container'], style[device])}>
      <div className={style['switcher-title']}>
        <SwitcherTitle textAlign={textAlign}>Я хочу знать про</SwitcherTitle>
      </div>
      <div className={style['switchers-body']}>
        <Responsive desktop>
          <div className={style['custom-switcher']}>
            {WANT_KNOW_TYPE.map(({ id, imgClass, text }) => (
              <div
                key={id}
                onClick={() => onActiveDealType(id)}
                className={clsx(style['custom-switcher-item'], id === dealType && style['active'])}
              >
                <div className={clsx(style['image'], style[imgClass])} />
                <div className={style['text']}>{text}</div>
              </div>
            ))}
          </div>
        </Responsive>
        <div className={style['switch']}>
          <span className={style['text']} onClick={() => onActiveOfferType(EOfferType.Apartment)}>
            Квартиры
          </span>
          <Switch
            value={offerType}
            checked={offerType === EOfferType.Suburban}
            onChange={() =>
              onActiveOfferType(offerType === EOfferType.Apartment ? EOfferType.Suburban : EOfferType.Apartment)
            }
          />
          <span className={style['text']} onClick={() => onActiveOfferType(EOfferType.Suburban)}>
            Дома
          </span>
        </div>
        <Responsive tablet phone>
          <div>
            <Select
              width={260}
              size="M"
              options={WANT_KNOW_TYPE.map(item => ({ value: item.id, label: item.text }))}
              onChange={e => onActiveDealType(e as EDealType)}
              value={dealType}
            />
          </div>
        </Responsive>
      </div>
    </div>
  );
};
